import React from 'react';
import { FiUsers, FiMessageCircle, FiPlay, FiHome, FiMail, FiGlobe } from 'react-icons/fi';
import MegaphoneIcon from '../MegaphoneIcon';
import ShieldCheckIcon from '../ShieldCheckIcon';

// icon keys used in helpContent.ts → the same icon sets as the rest of v2
export const HELP_ICONS: { [key: string]: JSX.Element } = {
    megaphone: <MegaphoneIcon />,
    users: <FiUsers />,
    message: <FiMessageCircle />,
    play: <FiPlay />,
    home: <FiHome />,
    mail: <FiMail />,
    globe: <FiGlobe />,
    shield: <ShieldCheckIcon />,
};
